export interface HostPageContext {
  page_location: string;
  page_path: string;
  page_referrer?: string;
  parent_page_url: string;
}

function isUsableUrl(url: string): boolean {
  return Boolean(url) && !url.startsWith('about:');
}

/**
 * Returns the real host page URL when the slider runs inside a same-origin iframe (e.g. srcdoc).
 */
export function getHostPageUrl(): string {
  try {
    if (window.parent && window.parent !== window) {
      const parentUrl = window.parent.location.href;
      if (isUsableUrl(parentUrl)) {
        return parentUrl;
      }
    }
  } catch {
    // Cross-origin parent: location is not readable.
  }

  if (isUsableUrl(window.location.href)) {
    return window.location.href;
  }

  return document.referrer || window.location.href;
}

export function getHostPageContext(): HostPageContext {
  const page_location = getHostPageUrl();

  try {
    const url = new URL(page_location);
    return {
      page_location,
      page_path: url.pathname + url.search,
      page_referrer: document.referrer || undefined,
      parent_page_url: page_location,
    };
  } catch {
    return {
      page_location,
      page_path: page_location,
      page_referrer: document.referrer || undefined,
      parent_page_url: page_location,
    };
  }
}

/**
 * Prefer the parent dataLayer when embedded; fall back to the current window.
 */
export function getDataLayer(): unknown[] | undefined {
  try {
    if (window.parent && window.parent !== window && window.parent.dataLayer) {
      return window.parent.dataLayer;
    }
  } catch {
    // Cross-origin parent.
  }

  return window.dataLayer;
}
